/*eslint-disable*/
// eslint-disable-next-line no-unused-vars
//行政人事模块接口设置
import {
  postRequest,
  postRequestParams,
  getRequest,
  fileUpload,
  postDataParams
} from '@/api/request' // 导入request中创建的axios实例
const administration = {
  /*接待申请*/
  reception: {
    /*新增&编辑接待申请*/
    recSave: (mode, params) => {
      return mode == 'add'
        ? postRequest('app/applyReception/add', params)
        : postRequest('app/applyReception/update', params)
    },
    /*获取详情*/
    details: id => {
      return getRequest('app/applyReception/details/' + id, {})
    },
    /*撤回/删除*/
    operate: (mode, id) => {
      return mode == 'hold'
        ? postRequest('app/applyReception/deleted/' + id, {})
        : postRequest('app/applyReception/applyReceptionRecall/' + id, {})
    }
  },
  /*加班申请*/
  overTime: {
    /*新增&编辑加班申请*/
    overSave: (mode, params) => {
      return mode == 'add'
        ? postRequest('app/overtime/addOvertime', params)
        : postRequest('app/overtime/updateOvertime', params)
    },
    /*获取详情*/
    details: id => {
      return getRequest('app/overtime/getOvertime/' + id, {})
    },
    /*撤回/删除*/
    operate: (mode, id) => {
      return mode == 'hold'
        ? getRequest('app/overtime/delete/' + id, {})
        : getRequest('app/overtime/recall/' + id, {})
    }
  },
  /*请假申请*/
  leave: {
    /*新增&编辑请假*/
    leaSave: (mode, params) => {
      return mode == 'add'
        ? postRequest('app/leave/addLeave', params)
        : postRequest('app/leave/updateLeave', params)
    },
    /*获取详情*/
    details: id => {
      return getRequest('app/leave/getLeave/' + id, {})
    },
    /*撤回/删除*/
    operate: (mode, id) => {
      return mode == 'hold'
        ? getRequest('app/leave/delete/' + id, {})
        : getRequest('app/leave/leaveRecall/' + id, {})
    },
    //获取请假天数 判断用户年假情况 王愿
    annualLeave: (params) => {
      return getRequest("apply/leave/getUserAnnualLeave", params);
    },
      //根据请假类型获取请假天数
    getLeaveDays: (params) => {
      return getRequest("app/leave/getLeaveDays", params);
    },
    //根据开始日期计算假期结束日期
    getEndTimeByType: (params) => {
      return getRequest("app/leave/getEndTimeByType", params);
    },
  },
  // 会议室申请
  meetingRoom:{
    /*会议室详情-陈国贵*/
    details: id => {
      return getRequest('app/meetingRoom/details/' + id, {})
    },
    /*新增&编辑会议室*/
    meetingRoomSave: (mode, params) => {
      return mode == 'add'
        ? postRequest('app/meetingRoom/add', params)
        : postRequest('app/meetingRoom/edit', params)
    },
    /*删除*/
    delete: id => {
      return getRequest('app/meetingRoom/delete/' + id, {})
    },
  },
  /*出差申请*/
  business: {
    /*新增&编辑出差申请*/
    busSave: (mode, params) => {
      return mode == 'add'
        ? postRequest('app/travel/addTravel', params)
        : postRequest('app/travel/updateTravel', params)
    },
    /*获取详情*/
    details: id => {
      return getRequest('app/travel/getTravel/' + id, {})
    },
    /*撤回/删除*/
    operate: (mode, id) => {
      return mode == 'hold'
        ? getRequest('app/travel/delete/' + id, {})
        : getRequest('app/travel/recall/' + id, {})
    }
  },
  /*用户出差变更申请接口*/
  travelChange: {
    /*新增&编辑出差申请*/
    busSave: (mode, params) => {
      return mode == 'add'
        ? postRequest('app/travelChange/add', params)
        : postRequest('app/travelChange/edit', params)
    },
    /*获取详情*/
    details: id => {
      return getRequest('app/travelChange/details/' + id, {})
    },
    /*撤回/删除*/
    operate: (mode, id) => {
      return mode == 'hold'
        ? getRequest('app/travelChange/delete/' + id, {})
        : getRequest('app/travelChange/recall/' + id, {})
    },
    // 选择需要变更的出差申请记录-分页-陈国贵
    selectTravelList: (pageNum, pageSize, params) => {
      return getRequest(
        "app/travelChange/selectTravelList/" + pageNum + "/" + pageSize,
        params
      );
    },
  },
  /*外出申请相关服务*/
  outing: {
    /*新增&编辑外出申请*/
    busSave: (mode, params) => {
      return mode == 'add'
        ? postRequest('app/outing/add', params)
        : postRequest('app/outing/edit', params)
    },
    /*获取详情*/
    details: id => {
      return getRequest('app/outing/details/' + id, {})
    },
    /*撤回/删除*/
    operate: (mode, id) => {
      return mode == 'hold'
        ? getRequest('app/outing/delete/' + id, {})
        : getRequest('app/outing/recall/' + id, {})
    }
  },
  /*查询物资领用详情信息接口-肖东*/
  materialApply: {
    details: id => {
      return getRequest("app/getMaterial/detailsWeb/" + id, {});
    },
  },

  //考核奖金结算申请
  bonus: {
    //考核奖金结算列表-陈国贵
    bonusList: (pageNum, pageSize, params) => {
      return postRequest('app/bonus/bonusList/' + pageNum + "/" + pageSize, params)
    },
    //新增和编辑菜单--陈国贵
    addEditBonus: (mode, params) => {
      if (mode == 'add') {
        return postRequest('app/bonus/add', params)
      } else {
        return postRequest('app/bonus/edit', params)
      }
    },
    //考核奖金结算申请的详情 --陈国贵
    details: (id) => {
      return getRequest('app/bonus/get/' + id, {})
    },
    //删除撤回
    deleteRecall: (mode, id) => {
      return mode == 'hold'
        ? getRequest('app/bonus/delete/' + id, {})
        : getRequest('app/bonus/recall/' + id, {})
    },
    //重新提交
    resubmit: (id) => {
      return getRequest("app/bonus/againSubmit/" + id, {});
    },

    //考核奖金结算项目列表-分页-陈国贵
    projectList: (pageNum, pageSize, params) => {
      return getRequest('app/bonus/projectList/' + pageNum + "/" + pageSize, params)
    },

    //项目考核奖金 项目计提比例--王愿
    percent: (id) => {
      return getRequest("project/assessment/technical/percent/" + id, {});
    },
    //项目考核奖金明细列表 --王愿
    workloadUids: (params) => {
      return getRequest("project/assessment/workloadUids/", params);
    },
  },
  /*物资报废申请-陈国贵*/
  scrapAsset: {
    /*我的物资报废申请*/
    myApplyList: (pageNum, pageSize, params) => {
      return postRequest('app/scrap/myApplyList/' + pageNum + "/" + pageSize, params)
    },
    /*未报废物资列表*/
    scrapFalselist: (pageNum, pageSize, params) => {
      return getRequest('app/scrap/materialList/' + pageNum + "/" + pageSize, params)
    },
    /*已报废物资列表*/
    scrapTruelist: (pageNum, pageSize, params) => {
      return getRequest('app/scrap/materialScrapList/' + pageNum + "/" + pageSize, params)
    },
    //新增和编辑
    addEdit: (mode, params) => {
      if (mode == 'add') {
        return postRequest('app/scrap/add', params)
      } else {
        return postRequest('app/scrap/edit', params)
      }
    },
    //删除撤回
    deleteRecall: (mode, id) => {
      return mode == 'hold'
        ? getRequest('app/scrap/delete/' + id, {})
        : getRequest('app/scrap/recall/' + id, {})
    },

    //重新提交
    resubmit: (id) => {
      return getRequest("apply/scrap/againSubmit/" + id, {});
    },
    //详情
    details: (id) => {
      return getRequest("app/scrap/get/" + id, {});
    },
  },
  // 培训课程模块--王愿
  course: {
    /*详情*/
    details: (id) => {
      return getRequest("base/lesson/detail/" + id, {});
    },

    /*新增浏览量*/
    addRead: (params) => {
      return postRequest('base/lesson/analysis/read/add', params)
    },
    /*新增下载量*/
    addDownload: (params) => {
      return postRequest('base/lesson/analysis/download/add', params)
    },

  },
    // 根据起止时间获取工作日天数
    getWorkDays: (params) => {
      return getRequest("base/restDay/getWorkDays", params);
    },
}

export default { administration }